export default {
  wrapper: {
    height: '708px',
    pt: '180px',
  },
};
